// 星春大吉 - 左下連結
'use client';

import { useSelector } from 'react-redux';
import { urlState } from '@/slices/urlSlice';
import Link from 'next/link';
import { OFFICIAL_URL } from '@/common/constant';

const LunarYearLeftLink = () => {
    const { forumUrl } = useSelector(urlState);

    return (
        <div className="space-y-[20px]">
            {/* app 下載 */}
            <div className="aspect-[360/202] max-w-[360px] relative [&>a]:w-[43%] [&>a]:trans [&>a:hover]:opacity-[.7]">
                <img src={OFFICIAL_URL.LUNAR_YEAR_CDN_BASE + 'qrcode.webp'} alt="box" />

                <a href={OFFICIAL_URL.APP_STORE} className="absolute bottom-[42%] right-[9%]">
                    <img src="/images/icon/apple_store.svg" alt="ios" />
                </a>

                <a href={OFFICIAL_URL.GOOGLE_PLAY} className="absolute bottom-[15%] right-[9%]">
                    <img src="/images/icon/google_play.svg" alt="android" />
                </a>
            </div>

            {/* 官網連結 */}
            <div className="space-y-[12px] [&_img]:trans [&_a]:relative">
                <Link href="/" className="group">
                    <img
                        className="absolute top-0 left-0 z-[-1]"
                        src={OFFICIAL_URL.LUNAR_YEAR_CDN_BASE + 'icon_web_hover.svg'}
                        alt="link"
                    />
                    <img
                        className="group-hover:opacity-[0]"
                        src={OFFICIAL_URL.LUNAR_YEAR_CDN_BASE + 'icon_web.svg'}
                        alt="link"
                    />
                </Link>
                <a href={forumUrl} className="group">
                    <img
                        className="absolute top-0 left-0 z-[-1]"
                        src={OFFICIAL_URL.LUNAR_YEAR_CDN_BASE + 'icon_forum_hover.svg'}
                        alt="link"
                    />
                    <img
                        className="group-hover:opacity-[0]"
                        src={OFFICIAL_URL.LUNAR_YEAR_CDN_BASE + 'icon_forum.svg'}
                        alt="link"
                    />
                </a>
            </div>
        </div>
    );
};

export default LunarYearLeftLink;
